import axios from 'axios';
import { getApiBaseUrl, getStoredAuthToken, handleUnauthorizedResponse } from './httpClient';

// Crear instancia de axios con configuración personalizada
const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Habilitar envío y recepción de cookies para rutas del chatbot público
});

// Interceptor para requests - añadir el token de autorización automáticamente
const addAuthInterceptor = (apiInstance: typeof api) => {
  apiInstance.interceptors.request.use(
    config => {
      const token = getStoredAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    error => Promise.reject(error)
  );
};

// Interceptor para responses - manejar errores de autorización
const addResponseInterceptor = (apiInstance: typeof api) => {
  apiInstance.interceptors.response.use(
    response => response,
    error => {
      if (error.response?.status === 401) {
        const requestUrl = error.config?.url || '';
        handleUnauthorizedResponse(requestUrl);
      }
      return Promise.reject(error);
    }
  );
};

// Aplicar interceptors
addAuthInterceptor(api);
addResponseInterceptor(api);

export default api;
